"use client";
const a = typeof navigator < "u", o = e(), n = u(), r = c(), f = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), m = (
  // iPads can claim to be MacIntel
  o.platform === "MacIntel" && o.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(o.platform)
), p = a && /apple/i.test(navigator.vendor), g = a && /android/i.test(n) || /android/i.test(r), d = a && n.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, l = r.includes("jsdom/");
function e() {
  if (!a)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t != null && t.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function c() {
  if (!a)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: s,
    version: i
  }) => `${s}/${i}`).join(" ") : navigator.userAgent;
}
function u() {
  if (!a)
    return "";
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform ?? "";
}
export {
  l as a,
  p as b,
  f as c,
  m as d,
  d as e,
  g as i
};
